export default function initSurveyChartBar() {
  const fills = document.querySelectorAll('[data-bar-fill]')

  if (!fills.length) return

  console.log('SurveyChartBar init', fills.length)

  const easeInOut = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2

  const countUp = (el, target, duration) => {
    const start = performance.now()

    const tick = (now) => {
      const elapsed = now - start
      const progress = Math.min(elapsed / duration, 1)
      el.textContent = Math.round(easeInOut(progress) * target) + '%'

      if (progress < 1) requestAnimationFrame(tick)
    }

    requestAnimationFrame(tick)
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      const fill = entry.target
      const value = parseInt(fill.closest('[data-survey-chart-bar]').dataset.value)
      const valueLabel = fill.querySelector('[data-bar-value]')
      const valueLabelMobile = fill.parentElement.querySelector('[data-bar-value-mobile]')
      const arrow = fill.parentElement.querySelector('[data-bar-arrow]')

      const containerWidth = fill.parentElement.offsetWidth
      const arrowWidth = arrow ? arrow.offsetWidth : 0
      const targetPx = (value / 100) * containerWidth
      const fillPct = (Math.max(0, targetPx - arrowWidth) / containerWidth) * 100

      fill.style.width = `${fillPct}%`
      fill.classList.remove('opacity-0')
      if (arrow) {
        arrow.style.left = `${fillPct}%`
        arrow.classList.remove('opacity-0')
      }

      // Animate mobile label: starts at arrow tip, travels to final position
      if (valueLabelMobile) {
        const arrowPct = (arrowWidth / containerWidth) * 100
        valueLabelMobile.style.transitionProperty = 'none'
        valueLabelMobile.style.left = `${arrowPct}%`
        valueLabelMobile.classList.remove('opacity-0')
        valueLabelMobile.offsetWidth // force reflow
        valueLabelMobile.style.transitionProperty = ''
        valueLabelMobile.style.left = `${value}%`
        countUp(valueLabelMobile, value, 1700)
        setTimeout(() => { valueLabelMobile.style.transitionProperty = 'none' }, 1700)
      }

      // Animate desktop label
      setTimeout(() => {
        valueLabel.classList.remove('opacity-0')
        countUp(valueLabel, value, 1260)
      }, 440)

      observer.unobserve(fill)
    })
  }, { threshold: 0.1 })

  fills.forEach((fill) => observer.observe(fill))
}
